import cn from "classnames";
import "./TabButtonDesktop.scss";
import OptimizelyEditProperty from "../OptimizelyEditProperty/OptimizelyEditProperty";

interface Props {
  text?: string;
  propertyName?: string;
  selected?: boolean;
  onClick: () => void;
}

const TabButtonDesktop = ({ text, propertyName, selected, onClick }: Props) => (
  <div className="tab-button-desktop-norad">
    <OptimizelyEditProperty propertyName={propertyName}>
      <button onClick={onClick} className="tab-button-desktop-norad__button">
        <span
          className={cn("tab-button-desktop-norad__text", {
            "tab-button-desktop-norad__text--selected": selected,
          })}
        >
          {text}
        </span>
      </button>
    </OptimizelyEditProperty>
  </div>
);
export default TabButtonDesktop;
